export default "__VITE_ASSET__BsOfiN_g__"